import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://zozo-burger.de';

export default function SEO({ title, description, path, type = 'website', image, noIndex = false }) {
  const fullTitle = title ? `${title} | ZOZO BURGER` : 'ZOZO BURGER – Frische Burger, Pizza & mehr | Lieferung & Abholung';
  const desc = description || 'ZOZO BURGER – Dein Premium Burger Restaurant in Rellingen & Henstedt-Ulzburg. Frische Burger, knusprige Pizza, Wraps & mehr. Jetzt online bestellen!';
  const url = path ? `${BASE_URL}${path}` : BASE_URL;
  const ogImage = image || `${BASE_URL}/images/og-image.jpg`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:site_name" content="ZOZO BURGER" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {/* No Index */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
